// extracted by mini-css-extract-plugin
export var closeButton = "_m1-2";
export var closeButtonIcon = "_m1-3";
export var lightboxContent = "_m1-1";
export var lightboxOverlay = "_m1-0";